import styled from 'styled-components';
import { color, fontSize, fontWeight, spacing } from '../../../theme';

export const StyledSkillsSoftItem = styled.li`
  margin-top: ${spacing('lg')};
  display: flex;
  align-items: center;
  text-align: left;
  font-size: ${fontSize('sm')};
  color: ${color('text_subtle')};
  p {
    margin: 0;
  }
`;

export const StyledSkillsSoftItemImg = styled.img`
  display: block;
  width: 3.5rem;
  max-height: 3.5rem;
  align-self: center;
  margin-right: ${spacing('md')};
`;

export const StyledSkillsSoftItemTitle = styled.h5`
  font-weight: ${fontWeight('black')};
  font-size: ${fontSize('md')};
  margin: 0;
  color: ${color('text_default')};
`;
